<template>
  <div class="vowels-test">
    <!-- <div class="hoverable-button">
      kaftor
    </div> -->
    <div style="color: blue;">
      vowels test
    </div>
    <!-- <div class="successful-vowel">
      {{ successfulVowels.VOWEL_O }}
      {{ successfulVowels.VOWEL_I }}
      {{ successfulVowels.VOWEL_E }}
      {{ successfulVowels.VOWEL_A }}
      {{ successfulVowels.VOWEL_SHVA }}
      {{ successfulVowels.VOWEL_U }}
    </div> -->
    <div class="successful-vowels">
      <div
        class="successful-vowel"
        :class="{ detected: vowelDetection }"
        :key="key"
        v-for="(vowelDetection, key) in detectedVowelObj"
      >
        {{ key }}: {{ vowelDetection ? 'מזוהה' : 'לא מזוהה' }}
      </div>
    </div>
    <!-- <select v-model="vowelToDetect" class="select">
      <option v-for="(vowel, i) of vowelsArr" :value="vowel" :key="i">
        {{ vowel }}
      </option>
    </select> -->
    <!-- <div class="left">
      > left
    </div>
    <div class="right">
      right <
    </div> -->
  </div>
</template>

<script>
// import appConstants from '@/config/constants';

export default {
  name: 'vowels-test',
  data() {
    return {
      detectedVowelObj: {
        VOWEL_I: false,
        VowelA: false,
        VOWEL_O: false,
        VOWEL_SHVA: false,
        VOWEL_E: false,
        VowelU: false
      },
      TEST_COMPONENT: true
      // vowelsArr: Object.keys(appConstants.vowels),
      // counters: {
      //   VOWEL_O: 0,
      //   VOWEL_I: 0,
      //   VOWEL_E: 0,
      //   VOWEL_A: 0,
      //   VOWEL_SHVA: 0,
      //   VOWEL_U: 0
      // }
      // successfulVowels: {
      //   VOWEL_O: null,
      //   VOWEL_I: null,
      //   VOWEL_E: null,
      //   VOWEL_A: null,
      //   VOWEL_SHVA: null,
      //   VOWEL_U: null
      // }
    };
  },
  methods: {
    testVowels(detectedVowelObj) {
      this.detectedVowelObj = detectedVowelObj;
      // for (const vowel in detectedVowelObj) {
      //   if (detectedVowelObj[vowel]) {
      //     this.counters[vowel] += 1;
      //   }
      //   if (this.counters[vowel] >= 10) {
      //     this.detectedVowelObj = {
      //       VOWEL_I: false,
      //       VowelA: false,
      //       VOWEL_O: false,
      //       VOWEL_SHVA: false,
      //       VOWEL_E: false,
      //       VowelU: false
      //     };
      //     this.detectedVowelObj[vowel] = true;
      //     this.counters[vowel] = 0;
      //   }
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.successful-vowels {
  font-weight: bold;
  font-size: 40px;
  position: fixed;
  left: 5vw;
}

.detected {
  background-color: green;
}
</style>
